import {
  AssignableCommunityRole,
  CommunityRole,
  UserStatus,
  CommunityTeamMemberRecord,
  CommunityViewPublic,
  FeedbackCategory,
} from "@bbb/model";

export class ApiClientError extends Error {
  constructor(
    message: string,
    public readonly status: number,
    public readonly details?: unknown
  ) {
    super(message);
  }
}

export interface ApiRequestOptions {
  //TODO remove PUT
  method?: "GET" | "POST" | "PUT" | "PATCH" | "DELETE";
  /**
   * JSON or FormData body passed to the request.
   */
  data?: unknown;
  /**
   * Querystring params appended to the request URL.
   */
  params?: Record<string, string | number | boolean>;
  /**
   * Legacy positional compatibility for wrappers not yet simplified.
   * Dashboard auth uses HttpOnly wallet-session cookies.
   */
  token?: string;
  signal?: AbortSignal;
  headers?: Record<string, string>;
  /**
   * Legacy option kept for wrapper compatibility. Authenticated requests rely
   * on the wallet-session cookie.
   */
  authRequired?: boolean;
}

export interface CommunityPage {
  items: CommunityViewPublic[];
  nextCursor?: string;
}

export interface CommunityTeamMember extends CommunityTeamMemberRecord {
  inviteId?: string;
  inviteToken?: string;
  inviteMethod?: "link";
  expiresAt?: number;
  invitedAt?: number;
}

export interface CommunityTeamMemberInvitePayload {
  communityId: string;
  userId: string;
  role?: AssignableCommunityRole;
}

export interface CommunityTeamMemberInviteResponse {
  communityId: string;
  userId: string;
  role: CommunityRole;
  status: UserStatus;
}

export interface CommunityTeamMemberStatusUpdatePayload {
  communityId: string;
  userId: string;
  role?: AssignableCommunityRole;
  status?: UserStatus;
}

export interface CommunityTeamMemberStatusUpdateResponse {
  communityId: string;
  userId: string;
  role: CommunityRole;
  status: UserStatus;
}

export interface AvatarUploadUrlRequest {
  contentType: string;
}

export interface AvatarUploadUrlResponse {
  uploadUrl: string;
  objectPath: string;
  expiresAt: string;
  contentType: string;
  maxBytes: number;
}

export interface AvatarCompleteRequest {
  objectPath: string;
}

export interface WalletChallengeRequest {
  address: string;
  domain?: string;
}

export interface SubmitFeedbackRequest {
  category: FeedbackCategory;
  message: string;
  projectName?: string;
  mediaFiles?: File[];
}

export interface SubmitFeedbackResponse {
  id: number;
}

export interface CommunityCreationInitResponse {
  communityId: string;
  upload: AvatarUploadUrlResponse;
}

export interface CommunityCreationCompleteRequest extends AvatarCompleteRequest {
  name: string;
}
